import React, { useState } from 'react';
import { Container, Stack, Typography, Tabs, Tab } from '@mui/material';
import CurrentMonthReport from './CurrentMonthReport';
import ThreeMonthReport from './ThreeMonthReport';
import SixMonthReport from './SixMonthReport';
import OneYearReport from './OneYearReport';

const AdminReports = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };
  return (
    <Container>
      <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
        <Typography variant="h4">Reports</Typography>
      </Stack>
      <Tabs value={tabIndex} onChange={handleTabChange} aria-label="report tabs">
        <Tab label="Current Month" />
        <Tab label="Past 3 Months" />
        <Tab label="Past 6 Months" />
        <Tab label="Past Year" />
      </Tabs>
      {tabIndex === 0 && <CurrentMonthReport />}
      {tabIndex === 1 && <ThreeMonthReport />}
      {tabIndex === 2 && <SixMonthReport />}
      {tabIndex === 3 && <OneYearReport />}
      </Container>
  );
};

export default AdminReports;